// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"90c18f35","464":"2c87b644","570":"e458a110","787":"67d6dba0","865":"a515c147"}[chunkId] + ".chunk.js";
};